import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";

export default function Select(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options,
    size,
    required,
    fullWidth = true,
    error = null,
    showNA = false,
    className,
    iconColor = "#555",
    ...other
  } = props;

  // An option may carry a `subtitle` explaining what choosing it will do — same shape
  // InputAuto already accepts. Only opt in when at least one option has one, so the
  // existing selects across the app keep their exact current rendering.
  const hasSubtitles = options.some((j) => j.subtitle);

  // The closed control must show the label alone; without this the two-line menu row
  // would be rendered inside the input box too. Keeps the showNA placeholder working.
  const renderValue = hasSubtitles
    ? (val) =>
        options.find((j) => j.id === val)?.label ??
        (showNA && (val === "" || val == null) ? "N/A" : "")
    : undefined;

  return (
    <FormControl
      variant={variant || "outlined"}
      size={size || "small"}
      fullWidth={fullWidth}
      required={required}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={options.some((j) => j.id === value) ? value : ""}
        onChange={onChange}
        className={className}
        MenuProps={{
          PaperProps: {
            className: "bg-white border border-gray-500 !rounded-[10px]",
          },
        }}
        IconComponent={(e) => (
          <KeyboardArrowDownRounded
            {...e}
            sx={{ color: `${iconColor} !important` }}
          />
        )}
        {...(renderValue && { renderValue })}
        {...(error && { error: true })}
        {...other}
      >
        {showNA && (
          <MenuItem value="">
            <em>N/A</em>
          </MenuItem>
        )}
        {options.map((item, index) => (
          <MenuItem key={index} value={item.id} disabled={item.disabled}>
            {item.subtitle ? (
              <ListItemText
                primaryTypographyProps={{ fontSize: "14px", color: "#333" }}
                secondaryTypographyProps={{ fontSize: "12px", color: "#777" }}
                sx={{ m: 0 }}
                primary={item.label}
                secondary={item.subtitle}
              />
            ) : (
              item.label
            )}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText className="error-color">{error}</FormHelperText>
      )}
    </FormControl>
  );
}
